module.exports = __webpack_public_path__ + "static/media/icon-order-cancel-red.b2d4ee49.svg";